module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crosshair-container ind-2"
  }, [_c('crosshair-svg'), _vm._v(" "), _c('crosshair-svg'), _vm._v(" "), _c('crosshair-svg'), _vm._v(" "), _c('crosshair-svg')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fae97e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/crosshair_background.vue
// module id = 632
// module chunks = 1